import { SharedInput } from "@components";
import { IAddressData, IAmphur, IDisplay, IProvince, ISubDistrict } from "@interfaces";
import { selectAuth, selectMerchant } from "@redux";
import { useNotify } from "@utils";
import { Button, Col, Row, Select } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { EditIcon, IConClose } from "./icon";
const { Option } = Select;
interface IProps {
    showAddress: boolean;
    handleCloseDetail: () => void;
    addressData: IAddressData;
    setAddressData: (value: any) => void;
    provinceList: IProvince[];
    amphurList: IAmphur[];
    subDistrictList: ISubDistrict[];
    onChangeProvince: (value: any) => void;
    onChangeAmphur: (value: any) => void;
    onChangeSubDistrict: (value: any) => void;
    setAddressText: (value: any, name: string) => void;
    confirmAddress: () => void;
}

export const ComponentPopUpAddress = (props: IProps) => {
    //page hooks
    const { t } = useTranslation();
    const { error } = useNotify();
    //redux states
    const { themes } = useSelector(selectMerchant);
    const { showConfirm, userInfo } = useSelector(selectAuth);
    const merchant = useSelector(selectMerchant);
    // const staticQuestion = merchant.signUpSettings?.staticQuestion;
    const [isConfirm, setIsConfirm] = useState<boolean>(false);
    const [display, setDisplay] = useState<IDisplay>({
        province: "",
        district: "",
        subDistrict: "",
    });
    //page redux
    let {
        showAddress,
        handleCloseDetail,
        addressData,
        provinceList,
        amphurList,
        subDistrictList,
        onChangeProvince,
        onChangeAmphur,
        onChangeSubDistrict,
        setAddressText,
        confirmAddress,
    } = props;

    useEffect(() => {
        if (!showConfirm) {
            setIsConfirm(false);
        }
    }, [showConfirm]);

    useEffect(() => {
        if (showAddress) {
            if (provinceList === undefined || provinceList === null) {
                provinceList = [];
            }
            if (amphurList === undefined || amphurList === null) {
                amphurList = [];
            }
            if (subDistrictList === undefined || subDistrictList === null) {
                subDistrictList = [];
            }
            let proObj = provinceList.find((item) => item?.province_id === addressData.province);
            let disObj = amphurList.find((item) => item?.amphur_id === addressData.district);
            let subObj = subDistrictList[parseInt(addressData?.subDistrict)];

            if (proObj !== undefined && disObj !== undefined && subObj !== undefined) {
                setDisplay({
                    province: proObj?.province_name_tha || "",
                    district: disObj?.amphur_name_tha || "",
                    subDistrict: subObj?.district_name_tha || "",
                });
                setIsConfirm(true);
            }
        }
    }, [showAddress]);

    const onSave = () => {
        if (
            addressData?.address !== "" &&
            addressData?.province !== "" &&
            addressData?.district !== "" &&
            addressData?.subDistrict !== "" &&
            addressData?.postCode !== ""
        ) {
            setIsConfirm(true);

            if (provinceList === undefined || provinceList === null) {
                provinceList = [];
            }
            if (amphurList === undefined || amphurList === null) {
                amphurList = [];
            }
            if (subDistrictList === undefined || subDistrictList === null) {
                subDistrictList = [];
            }

            let proObj = provinceList.find((item) => item?.province_id === addressData.province);
            let disObj = amphurList.find((item) => item?.amphur_id === addressData.district);
            let subObj = subDistrictList[parseInt(addressData?.subDistrict)];
            setDisplay({
                province: proObj?.province_name_tha || "",
                district: disObj?.amphur_name_tha || "",
                subDistrict: subObj?.district_name_tha || "",
            });
        } else {
            error("please add address");
        }
    };

    const onConfirm = () => {
        confirmAddress();
    };

    return (
        <StyledContainerHistoryDetailDone isConfirm={isConfirm} themeColor={themes?.themeColor!}>
            <div className="header">
                <div className="confirmation text-sub-header">
                    {!isConfirm ? t("page.enter_delivery_address") : t("page.confirm_address")}
                </div>

                <div className="close" onClick={handleCloseDetail}>
                    <IConClose />
                </div>
            </div>
            <div className="content-layout">
                {isConfirm && (
                    <div className="confirm-section">
                        <div className="edit-icon" onClick={() => setIsConfirm(false)}>
                            <EditIcon size={20} />
                        </div>
                        <p>
                            {addressData?.address} &nbsp;
                            {display?.province} &nbsp;
                            {display.district} &nbsp;
                            {display.subDistrict} &nbsp;
                            {addressData?.postCode}
                        </p>
                    </div>
                )}
                {!isConfirm && (
                    <StyledSurvey mainColor={themes?.themeColor!}>
                        <br />
                        <div>
                            <p className="input-title ">{t("page.address")}</p>
                            <SharedInput
                                name="freeTextAnswer"
                                value={addressData?.address}
                                onChange={(e: React.ChangeEvent<HTMLFormElement>) =>
                                    setAddressText(e.target.value, "address")
                                }
                                styleParent={{ height: "48px" }}
                                style={{
                                    backgroundColor: "white",
                                    border: "1px solid gray",
                                }}
                            />
                            <div>
                                <Row gutter={16}>
                                    <Col span={12}>
                                        <p className="input-title ">{t("page.province")}</p>
                                    </Col>
                                    <Col span={12}>
                                        <p className="input-title ">{t("page.county")}</p>
                                    </Col>
                                    <Col span={12}>
                                        <Select
                                            onChange={onChangeProvince}
                                            value={
                                                addressData.province === ""
                                                    ? undefined
                                                    : addressData.province
                                            }
                                            placeholder={t("page.province")}
                                        >
                                            {provinceList?.length > 0 &&
                                                provinceList?.map((pItem, pIndex) => {
                                                    return (
                                                        <Option
                                                            value={pItem?.province_id}
                                                            key={pIndex}
                                                        >
                                                            {pItem.province_name_tha}
                                                        </Option>
                                                    );
                                                })}
                                        </Select>
                                    </Col>
                                    <Col span={12}>
                                        <Select
                                            onChange={onChangeAmphur}
                                            value={
                                                addressData.district === ""
                                                    ? undefined
                                                    : addressData.district
                                            }
                                            placeholder={t("page.county")}
                                        >
                                            {amphurList?.length > 0 &&
                                                amphurList?.map((aItem, aIndex) => {
                                                    return (
                                                        <Option
                                                            value={aItem?.amphur_id}
                                                            key={aIndex}
                                                        >
                                                            {aItem?.amphur_name_tha}
                                                        </Option>
                                                    );
                                                })}
                                        </Select>
                                    </Col>
                                </Row>
                            </div>
                            <div>
                                <Row gutter={16}>
                                    <Col span={12}>
                                        <p className="input-title ">{t("page.district")}</p>
                                    </Col>
                                    <Col span={12}>
                                        <p className="input-title ">{t("page.zipcode")}</p>
                                    </Col>
                                    <Col span={12}>
                                        <Select
                                            onChange={onChangeSubDistrict}
                                            value={
                                                addressData.subDistrict === ""
                                                    ? undefined
                                                    : parseInt(addressData.subDistrict)
                                            }
                                            placeholder={t("page.district")}
                                        >
                                            {subDistrictList?.length > 0 &&
                                                subDistrictList?.map((sItem, sIndex) => {
                                                    return (
                                                        <Option value={sIndex} key={sIndex}>
                                                            {sItem?.district_name_tha}
                                                        </Option>
                                                    );
                                                })}
                                        </Select>
                                    </Col>
                                    <Col span={12}>
                                        <SharedInput
                                            name="freeTextAnswer"
                                            value={addressData?.postCode}
                                            onChange={(e: React.ChangeEvent<HTMLFormElement>) =>
                                                setAddressText(e.target.value, "postCode")
                                            }
                                            styleParent={{ height: "48px" }}
                                            style={{
                                                backgroundColor: "white",
                                                border: "1px solid gray",
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </StyledSurvey>
                )}
                <Button className="save-btn" onClick={!isConfirm ? onSave : onConfirm}>
                    {!isConfirm ? t("page.save") : t("page.confirm")}
                </Button>
            </div>
        </StyledContainerHistoryDetailDone>
    );
};

const StyledContainerHistoryDetailDone = styled.div<{ isConfirm: boolean; themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    flex-direction: column;
    justify-content: end;
    transition: 2s !important;
    animation: opacity 0.5s !important;
    @keyframes opacity {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    .header {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
        animation: bottomtotop 1s !important;
        position: relative;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        .close {
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
    }
    .content-layout {
        height: ${(p) => (p.isConfirm === false ? `70vh` : "25vh")};
        background: ${(p) => p.theme.colors.white};
        padding-top: 24px;
        padding-bottom: 24px;
        width: 100%;
        animation: bottomtotop 1s !important;
        position: relative;
        padding: 24px;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        @media (max-width: ${(p) => p.theme.breakPoints.breakMobileMax}) {
            overflow: scroll;
        }
        .confirm-section {
            .edit-icon {
                cursor: pointer;
                text-align: right;
            }
        }
        .save-btn {
            margin-top: 40px;
            width: 100%;
            height: 58px;
            border-radius: 50px;
            background-color: ${(p) => p.themeColor};
            color: white;
        }
    }
`;

const StyledSurvey = styled.div<{ mainColor: string }>`
    /* padding: 20px ; */
    p {
        color: #3c3c3c;
        font-size: 16px;
        margin-bottom: 0px;
    }
    .group-title-section {
        display: flex;
        .color-section {
            background-color: ${(p) => p.mainColor};
            border-radius: 5px;
        }
        .group-title {
            font-size: 18px;
            font-weight: 600;
            /* border-left: 4px solid ${(p) => p.mainColor}; */
            padding-left: 10px;
            line-height: 30px;
            /* margin-top: 3px; */
        }
    }
    .ant-select {
        width: 100%;
    }
    .ant-select-selection {
        box-shadow: none !important;
        height: 48px;
        font-size: 16px;
        color: inherit;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-radius: 6px;
        background-color: #fff;
        border: 1px solid #dadada !important;
        cursor: default;
        width: 100% !important;
    }
    .intl-tel-input input {
        border-radius: 6px;
    }
    .term-field {
        display: flex;
        justify-content: center;
    }
    .btn-section {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 20px;
        .btn {
            width: 100%;
            height: 55px;
            border-radius: 500px;
            font-size: 16px;
        }
        .back {
            color: #f22f46;
            background-color: #fff;
            border: 1px solid #f22f46;
        }
        .save {
            //
            background-color: #f22f46;
            color: white;
        }
    }
    .input-title {
        margin: 12px 0 3px 0;
        color: #919191;
        font-size: 16px;
        font-weight: 500;
    }
    .multiple-title {
        margin-bottom: 0px;
        line-height: 16px;
    }
    .ant-select-selection--multiple {
        .ant-select-arrow {
            margin-top: 0px;
        }
    }
`;
